// Phase 40 Plan 02 Task 1 — useSession hook.
// Thin wrapper around AuthContext so consumer components don't import the
// context directly.

import { useContext } from 'react';
import { AuthContext } from './AuthProvider.jsx';

export function useSession() {
  return useContext(AuthContext);
}
